import { defineStore } from 'pinia'
import { accountsApi } from '@/common/api/account'

export const useUserStore = defineStore('user', {
    state: () => ({
        user: null,
        modules: [],
        groups: [],
        favorites: [],
        loading: false,
        fetched: false,
    }),
    
    actions: {
        init() {
            this.fetchUser()
        },

        async fetchUser() {
            if (this.fetched) return

            this.loading = true

            try {
                const data = await accountsApi.user()
                this.user = data || null
                this.modules = data?.modules || []
                this.groups = data?.groups || []
                this.favorites = data?.favorites || []
            } finally {
                this.loading = false
                this.fetched = true
            }
        },

        async login(credentials) {
            this.loading = true

            try {
                await accountsApi.login(credentials)
            } finally {
                this.loading = false
            }
        },

        async logout() {
            this.loading = true
            this.user = null
            this.modules = []
            this.groups = []
            this.favorites = []

            try {
                await accountsApi.logout()
            } finally {
                this.loading = false
                this.fetched = false
            }
        },

        reload() {
            this.fetched = false
            this.fetchUser()
        },

        hasGroup(group) {
            return this.groups.includes(group)
        },

        isGod() {
            return this.hasGroup("god")
        },

        canAccessModule(moduleId) {
            return this.modules.includes(moduleId)
        }
    },
})
